import { useState, useEffect } from 'react';

export const useBasicTableState = () => {
  const [detailOpen, setDetailOpen] = useState(false);
  // shows if items are being loaded
  const [loadingItems, setLoadingItems] = useState(true);
  const [loadingItemsHistory, setLoadingItemsHistory] = useState(false);
  const [loadingDiscounts, setLoadingDiscounts] = useState(true);
  const [loadingGetProductStatus, setLoadingGetProductStatus] = useState(true);

  // items container
  const [items, setItems] = useState([]);
  const [itemsHistory, setItemsHistory] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [productStatuses, setProductStatuses] = useState([]);

  // stored the selected user index
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [selectedItemHistoryIndex, setSelectedItemHistoryIndex] = useState(-1);

  const selectedItem =
    selectedItemIndex >= 0 && items.length ? items[selectedItemIndex] : {};
  const selectedItemHistory =
    selectedItemHistoryIndex >= 0 && itemsHistory.length
      ? itemsHistory[selectedItemHistoryIndex]
      : {};

  return {
    detailOpen,
    setDetailOpen,
    loadingItems,
    setLoadingItems,
    items,
    setItems,
    selectedItemIndex,
    setSelectedItemIndex,
    selectedItem,
    loadingItemsHistory,
    setLoadingItemsHistory,
    itemsHistory,
    setItemsHistory,
    selectedItemHistoryIndex,
    setSelectedItemHistoryIndex,
    selectedItemHistory,
    loadingDiscounts,
    setLoadingDiscounts,
    discounts,
    setDiscounts,
    loadingGetProductStatus,
    setLoadingGetProductStatus,
    productStatuses,
    setProductStatuses,
  };
};
